// import React, { useEffect, useState } from "react";
// import {
//   Card,
//   CardContent,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   Chip,
//   Box,
//   Tabs,
//   Tab,
//   TablePagination,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   Button,
//   Pagination,
// } from "@mui/material";
// import {
//   Visibility as ViewIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Add as AddIcon,
//   Warning as WarningIcon,
// } from "@mui/icons-material";
// import "../../styles/PromoCode.scss";
// import ViewPromoCode from "./ViewPromoCode";
// import CreatePromoCode from "./CreatePromoCode";
// import { useNavigate } from "react-router-dom";
// import { EDITPROMO, VIEWPROMO } from "../../component/common/Routes/AppRoutes";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   deletePromoCodeRequest,
//   fetchAllPromoCodeRequest,
//   resetDeletePromoCode,
// } from "../../redux/PromoCode/PromoCodeAction";
// import Loading from "../../component/ui/Loading";
// import { useLocation } from "react-router-dom";
// import CustomButton from "../../component/ui/FormFields/Button";
// import { toast, ToastContainer } from 'react-toastify';
// import SearchAndButtonTab from "../../component/ui/SearchAndButtonTab";

// const PromoCodeManagement = () => {
//   const [activeTab, setActiveTab] = useState(0);
//   const location = useLocation();
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [selectedPromoCode, setSelectedPromoCode] = useState(null);
//   const deleteLoading = useSelector(
//     (state) => state.promoCode.deletePromoCode.loading
//   );
//   const deleteSuccess = useSelector(
//     (state) => state.promoCode.deletePromoCode.success
//   );
//   const deleteError = useSelector(
//     (state) => state.promoCode.deletePromoCode.error
//   );
//   const pageNumber = location.state?.page ?? 1;
//   const [page, setPage] = useState(pageNumber);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { promoCodeDetails } = useSelector((state) => state.promoCode);
//   const loading = useSelector(
//     (state) => state.promoCode.promoCodeDetails.loading
//   );
//   const promoCodeData = promoCodeDetails?.data;
//   const totalSize = promoCodeDetails?.totalRecords || 0;
//   const totalPages = Math.ceil(totalSize / rowsPerPage);
//   useEffect(() => {
//     dispatch(
//       fetchAllPromoCodeRequest({
//         pageNo: page,
//         pageSize: rowsPerPage,
//         pagination_required: true,
//       })
//     );
//   }, [activeTab, page]);

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "Approved":
//         return "#1e8f028f";
//       case "Rejected":
//         return "#f44336";
//       case "Pending":
//         return "#ff9800";
//       case "Inactive":
//         return "#f44336";
//       case "Active":
//         return "#1e8f028f";
//       default:
//         return "default";
//     }
//   };

//   const handleView = (id) => {
//     navigate(`${VIEWPROMO.replace(":id", id)}`);
//   };

//   const handleEdit = (id) => {
//     navigate(`${EDITPROMO.replace(":id", id)}`);
//   };

//   const handleDelete = (row) => {
//     setSelectedPromoCode(row);
//     setDeleteDialogOpen(true);
//   };

//   const handleDeleteConfirm = () => {
//     dispatch(deletePromoCodeRequest(selectedPromoCode.id));
//   };

//   const handleDeleteCancel = () => {
//     setDeleteDialogOpen(false);
//     setSelectedPromoCode(null);
//   };

//   if (loading) {
//     return <Loading text="Loading Promo Code Details..." />;
//   }
//   const handlePageChange = (event, newPage) => {
//     setPage(newPage);
//   };
//   if (deleteSuccess) {
//     toast.success("Promo Code Deleted Successfully", {
//       position: "top-center",
//       autoClose: 3000,
//       onClose: () => {
//         dispatch(resetDeletePromoCode());
//         dispatch(
//       fetchAllPromoCodeRequest({
//         pageNo: page,
//         pageSize: rowsPerPage,
//         pagination_required: true,
//       })
//     );
//         setDeleteDialogOpen(false);
//         setSelectedPromoCode(null);
//       },
//     });
//   }
//   if (deleteError) {
//     toast.error("Failed to delete promo code", {
//       position: "top-center",
//       autoClose: 3000,
//       onClose: () => {
//         dispatch(resetDeletePromoCode());
//       },
//     });
//   }
//   return (
//     <>
//     <ToastContainer />
//     <Box
//       sx={{
//         margin: "20px",
//         height: "100vh",
//         overflow: "auto",
//         "&::-webkit-scrollbar": {
//           width: "8px",
//         },
//         "&::-webkit-scrollbar-track": {
//           background: "#f1f1f1",
//           borderRadius: "4px",
//         },
//         "&::-webkit-scrollbar-thumb": {
//           background: "#c1c1c1",
//           borderRadius: "4px",
//         },
//         "&::-webkit-scrollbar-thumb:hover": {
//           background: "#a8a8a8",
//         },
//       }}
//     >
//       <Card sx={{ maxWidth: "100%" }}>
//         <CardContent>
//           {/* Header */}
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               mb: 3,
//             }}
//           >
//             <Box>
//               <Typography
//                 variant="h5"
//                 component="h2"
//                 sx={{ fontWeight: 600, mb: 1 }}
//               >
//                 Promocode Management
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Create and manage promotional codes with dynamic discount
//                 calculation
//               </Typography>
//             </Box>

//           </Box>

//           {/* Tabs */}
//           <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
//             <Tabs
//               value={activeTab}
//               onChange={handleTabChange}
//               textColor="primary"
//               indicatorColor="primary"
//             >
//               <Tab
//                 label="View Promocodes"
//                 sx={{
//                   textTransform: "none",
//                   fontWeight: activeTab === 0 ? 600 : 400,
//                   fontSize: "14px",
//                 }}
//               />
//               <Tab
//                 label="Create Promocode"
//                 icon={<AddIcon />}
//                 iconPosition="start"
//                 sx={{
//                   textTransform: "none",
//                   fontWeight: activeTab === 1 ? 600 : 400,
//                   fontSize: "14px",
//                 }}
//               />
//             </Tabs>
//           </Box>

//           {activeTab === 1 && <CreatePromoCode setTab={setActiveTab} />}

//           {activeTab === 0 && (
//             <Box>
//               <TableContainer
//                 component={Paper}
//                 elevation={0}
//                 sx={{ border: "1px solid #e0e0e0" }}
//               >
//                 <Table sx={{ minWidth: 1200 }}>
//                   <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
//                     <TableRow>
//                       <TableCell
//                         sx={{
//                           fontWeight: 600,
//                           fontSize: "11px",
//                           textTransform: "uppercase",
//                           color: "text.secondary",
//                           letterSpacing: "0.5px",
//                         }}
//                       >
//                         Code & Title
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           fontWeight: 600,
//                           fontSize: "11px",
//                           textTransform: "uppercase",
//                           color: "text.secondary",
//                           letterSpacing: "0.5px",
//                         }}
//                       >
//                         Description
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           fontWeight: 600,
//                           fontSize: "11px",
//                           textTransform: "uppercase",
//                           color: "text.secondary",
//                           letterSpacing: "0.5px",
//                         }}
//                       >
//                         Price
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           fontWeight: 600,
//                           fontSize: "11px",
//                           textTransform: "uppercase",
//                           color: "text.secondary",
//                           letterSpacing: "0.5px",
//                         }}
//                       >
//                         Discount(%)
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           fontWeight: 600,
//                           fontSize: "11px",
//                           textTransform: "uppercase",
//                           color: "text.secondary",
//                           letterSpacing: "0.5px",
//                         }}
//                       >
//                         Usage
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           fontWeight: 600,
//                           fontSize: "11px",
//                           textTransform: "uppercase",
//                           color: "text.secondary",
//                           letterSpacing: "0.5px",
//                         }}
//                       >
//                         Valid Until
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           fontWeight: 600,
//                           fontSize: "11px",
//                           textTransform: "uppercase",
//                           color: "text.secondary",
//                           letterSpacing: "0.5px",
//                         }}
//                       >
//                         Status
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           fontWeight: 600,
//                           fontSize: "11px",
//                           textTransform: "uppercase",
//                           color: "text.secondary",
//                           letterSpacing: "0.5px",
//                         }}
//                       >
//                         Approval Status
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           fontWeight: 600,
//                           fontSize: "11px",
//                           textTransform: "uppercase",
//                           color: "text.secondary",
//                           letterSpacing: "0.5px",
//                         }}
//                       >
//                         Actions
//                       </TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {promoCodeData.map((row) => (
//                       <TableRow
//                         key={row.id}
//                         sx={{
//                           "&:hover": { backgroundColor: "#f9f9f9" },
//                           "& td": { borderBottom: "1px solid #f0f0f0" },
//                         }}
//                       >
//                         <TableCell sx={{ verticalAlign: "top" }}>
//                           <Box>
//                             <Typography
//                               variant="body2"
//                               sx={{ fontWeight: 500, mb: 0.5 }}
//                             >
//                               {row.discount_code}
//                             </Typography>
//                             <Typography
//                               variant="caption"
//                               color="text.secondary"
//                             >
//                               {row.title}
//                             </Typography>
//                           </Box>
//                         </TableCell>
//                         <TableCell sx={{ maxWidth: 300, verticalAlign: "top" }}>
//                           <Typography
//                             variant="body2"
//                             sx={{
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                               display: "-webkit-box",
//                               WebkitLineClamp: 2,
//                               WebkitBoxOrient: "vertical",
//                               lineHeight: 1.4,
//                             }}
//                           >
//                             {row.description}
//                           </Typography>
//                         </TableCell>
//                         <TableCell sx={{ verticalAlign: "top" }}>
//                           <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                             {row.discount_value}
//                           </Typography>
//                         </TableCell>
//                         <TableCell sx={{ verticalAlign: "top" }}>
//                           <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                             {row.discount_percent}
//                           </Typography>
//                         </TableCell>
//                         <TableCell sx={{ verticalAlign: "top" }}>
//                           <Box sx={{ display: "flex", alignItems: "center" }}>
//                             <Box
//                               sx={{
//                                 width: 8,
//                                 height: 8,
//                                 borderRadius: "50%",
//                                 backgroundColor: "#2196f3",
//                                 mr: 1,
//                               }}
//                             />
//                             <Typography variant="body2">{`${row.usage_count}/${row.usage_limit}`}</Typography>
//                           </Box>
//                         </TableCell>
//                         <TableCell sx={{ verticalAlign: "top" }}>
//                           <Box sx={{ display: "flex", alignItems: "center" }}>
//                             <Box
//                               sx={{
//                                 width: 8,
//                                 height: 8,
//                                 borderRadius: "50%",
//                                 backgroundColor: "#ff9800",
//                                 mr: 1,
//                               }}
//                             />
//                             <Typography variant="body2">
//                               {row.valid_to}
//                             </Typography>
//                           </Box>
//                         </TableCell>
//                         <TableCell sx={{ verticalAlign: "top" }}>
//                           <Chip
//                             label={row.status === 1 ? "Active" : "Inactive"}
//                             size="small"
//                             sx={{
//                               minWidth: 80,
//                               fontWeight: 500,
//                               color: "white",
//                               backgroundColor: getStatusColor(
//                                 row.status === 1 ? "Active" : "Inactive"
//                               ),
//                               fontSize: "12px",
//                             }}
//                           />
//                         </TableCell>
//                         <TableCell sx={{ verticalAlign: "top" }}>
//                           <Chip
//                             label={
//                               row.approval_status === 1
//                                 ? "Approved"
//                                 : row.approval_status === 2
//                                 ? "Pending"
//                                 : "Rejected"
//                             }
//                             size="small"
//                             sx={{
//                               minWidth: 80,
//                               color: "white",
//                               fontWeight: 500,
//                               fontSize: "12px",
//                               backgroundColor: getStatusColor(
//                                 row.approval_status === 1
//                                   ? "Approved"
//                                   : row.approval_status === 2
//                                   ? "Pending"
//                                   : "Rejected"
//                               ),
//                             }}
//                           />
//                         </TableCell>
//                         <TableCell sx={{ verticalAlign: "top" }}>
//                           <Box sx={{ display: "flex", gap: 1 }}>
//                             <IconButton
//                               size="small"
//                               onClick={() => handleView(row.id)}
//                               sx={{
//                                 color: "#2196f3",
//                                 backgroundColor: "rgba(33, 150, 243, 0.1)",
//                                 "&:hover": {
//                                   backgroundColor: "rgba(33, 150, 243, 0.2)",
//                                 },
//                               }}
//                             >
//                               <ViewIcon fontSize="small" />
//                             </IconButton>
//                             <IconButton
//                               size="small"
//                               onClick={() => handleEdit(row.id)}
//                               sx={{
//                                 color: "#ff9800",
//                                 backgroundColor: "rgba(255, 152, 0, 0.1)",
//                                 "&:hover": {
//                                   backgroundColor: "rgba(255, 152, 0, 0.2)",
//                                 },
//                               }}
//                             >
//                               <EditIcon fontSize="small" />
//                             </IconButton>
//                             <IconButton
//                               size="small"
//                               onClick={() => handleDelete(row)}
//                               sx={{
//                                 color: "#f44336",
//                                 backgroundColor: "rgba(244, 67, 54, 0.1)",
//                                 "&:hover": {
//                                   backgroundColor: "rgba(244, 67, 54, 0.2)",
//                                 },
//                               }}
//                             >
//                               <DeleteIcon fontSize="small" />
//                             </IconButton>
//                           </Box>
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>

//               {/* <TablePagination
//                 rowsPerPageOptions={[5, 10, 25]}
//                 component="div"
//                 count={promoCodeData.length}
//                 rowsPerPage={rowsPerPage}
//                 page={page}
//                 onPageChange={handleChangePage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
//               /> */}
//               <Box className="button-box">
//                 {promoCodeData?.length > 0 && (
//                   <Pagination
//                     count={totalPages}
//                     page={page}
//                     onChange={handlePageChange}
//                     color="primary"
//                   />
//                 )}
//               </Box>
//             </Box>
//           )}
//         </CardContent>

//         {/* Delete Confirmation Dialog */}
//         <Dialog
//           open={deleteDialogOpen}
//           onClose={handleDeleteCancel}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//               color: "#f44336",
//             }}
//           >
//             <WarningIcon />
//             Delete Promo Code
//           </DialogTitle>
//           <DialogContent>
//             <DialogContentText>
//               Are you sure you want to delete the following promo code?
//             </DialogContentText>
//             {selectedPromoCode && (
//               <Box sx={{ mt: 2, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
//                 <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
//                   Code: {selectedPromoCode.discount_code}
//                 </Typography>
//                 <Typography
//                   variant="body2"
//                   color="text.secondary"
//                   sx={{ mb: 0.5 }}
//                 >
//                   Title: {selectedPromoCode.title}
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   Discount: {selectedPromoCode.discount_percent}%
//                 </Typography>
//               </Box>
//             )}
//             <DialogContentText sx={{ mt: 2, color: "#f44336" }}>
//               This action cannot be undone.
//             </DialogContentText>
//           </DialogContent>
//           <DialogActions sx={{ p: 2 }}>
//             <CustomButton
//               variant="contained"
//               className="cancel-button"
//               type="button"
//               text={"Cancle"}
//               onClick={handleDeleteCancel}
//             />
//             <CustomButton
//               variant="contained"
//               className="success-button"
//               type="button"
//               loading={deleteLoading}
//               text={"Delete"}
//               onClick={handleDeleteConfirm}
//             />
//           </DialogActions>
//         </Dialog>
//       </Card>
//     </Box>
//     </>
//   );
// };

// export default PromoCodeManagement;
import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
  Box,
  Tabs,
  Tab,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Pagination,
  TextField, // Added TextField for search
  InputAdornment, // Added for search icon
} from "@mui/material";
import {
  Visibility as ViewIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  Warning as WarningIcon,
  Search as SearchIcon, // Added search icon
} from "@mui/icons-material";
import "../../styles/PromoCode.scss";
import ViewPromoCode from "./ViewPromoCode";
import CreatePromoCode from "./CreatePromoCode";
import { useNavigate } from "react-router-dom";
import { EDITPROMO, VIEWPROMO } from "../../component/common/Routes/AppRoutes";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePromoCodeRequest,
  fetchAllPromoCodeRequest,
  resetDeletePromoCode,
} from "../../redux/PromoCode/PromoCodeAction";
import Loading from "../../component/ui/Loading";
import { useLocation } from "react-router-dom";
import CustomButton from "../../component/ui/FormFields/Button";
import { toast, ToastContainer } from "react-toastify";
import SearchAndButtonTab from "../../component/ui/SearchAndButtonTab";

const PromoCodeManagement = () => {
  const [activeTab, setActiveTab] = useState(0);
  const location = useLocation();
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedPromoCode, setSelectedPromoCode] = useState(null);
  const [searchTerm, setSearchTerm] = useState(""); // State for search term
  const [searchTimeout, setSearchTimeout] = useState(null); // For debounced search

  const deleteLoading = useSelector(
    (state) => state.promoCode.deletePromoCode.loading
  );
  const deleteSuccess = useSelector(
    (state) => state.promoCode.deletePromoCode.success
  );
  const deleteError = useSelector(
    (state) => state.promoCode.deletePromoCode.error
  );
  const pageNumber = location.state?.page ?? 1;
  const [page, setPage] = useState(pageNumber);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { promoCodeDetails } = useSelector((state) => state.promoCode);
  const loading = useSelector(
    (state) => state.promoCode.promoCodeDetails.loading
  );
  const promoCodeData = promoCodeDetails?.data;
  const totalSize = promoCodeDetails?.totalRecords || 0;
  const totalPages = Math.ceil(totalSize / rowsPerPage);

  useEffect(() => {
    dispatch(
      fetchAllPromoCodeRequest({
        pageNo: page,
        pageSize: rowsPerPage,
        pagination_required: true,
        search: searchTerm, // Add search term to API call
      })
    );
  }, [activeTab, page, rowsPerPage, searchTimeout]); // Added searchTerm to dependencies

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1); // Reset to first page when changing rows per page
  };

  // Handle search input with debouncing
  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    setTimeout(() => {
      setSearchTimeout(value);
      setPage(1);
    }, 1000); // 500ms debounce
  };

  // Clear search
  const handleClearSearch = () => {
    setSearchTerm("");
    setSearchTimeout(null);
    setPage(1);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Approved":
        return "#1e8f028f";
      case "Rejected":
        return "#f44336";
      case "Pending":
        return "#ff9800";
      case "Inactive":
        return "#f44336";
      case "Active":
        return "#1e8f028f";
      default:
        return "default";
    }
  };

  const handleView = (id) => {
    navigate(`${VIEWPROMO.replace(":id", id)}`);
  };

  const handleEdit = (id) => {
    navigate(`${EDITPROMO.replace(":id", id)}`);
  };

  const handleDelete = (row) => {
    setSelectedPromoCode(row);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = () => {
    dispatch(deletePromoCodeRequest(selectedPromoCode.id));
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setSelectedPromoCode(null);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  if (deleteSuccess) {
    toast.success("Promo Code Deleted Successfully", {
      position: "top-center",
      autoClose: 3000,
      onClose: () => {
        dispatch(resetDeletePromoCode());
        dispatch(
          fetchAllPromoCodeRequest({
            pageNo: page,
            pageSize: rowsPerPage,
            pagination_required: true,
            search: searchTerm,
          })
        );
        setDeleteDialogOpen(false);
        setSelectedPromoCode(null);
      },
    });
  }

  if (deleteError) {
    toast.error("Failed to delete promo code", {
      position: "top-center",
      autoClose: 3000,
      onClose: () => {
        dispatch(resetDeletePromoCode());
      },
    });
  }

  if (loading) {
    return <Loading text="Loading Promo Code Details..." />;
  }

  return (
    <>
      <ToastContainer />
      <Box
        sx={{
          margin: "20px",
          height: "100vh",
          overflow: "auto",
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#c1c1c1",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#a8a8a8",
          },
        }}
      >
        <Card sx={{ maxWidth: "100%" }}>
          <CardContent>
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
              }}
            >
              <Box>
                <Typography
                  variant="h5"
                  component="h2"
                  sx={{ fontWeight: 600, mb: 1 }}
                >
                  Promocode Management
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Create and manage promotional codes with dynamic discount
                  calculation
                </Typography>
              </Box>
            </Box>

            {/* Tabs */}
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                textColor="primary"
                indicatorColor="primary"
              >
                <Tab
                  label="View Promocodes"
                  sx={{
                    textTransform: "none",
                    fontWeight: activeTab === 0 ? 600 : 400,
                    fontSize: "14px",
                  }}
                />
                <Tab
                  label="Create Promocode"
                  icon={<AddIcon />}
                  iconPosition="start"
                  sx={{
                    textTransform: "none",
                    fontWeight: activeTab === 1 ? 600 : 400,
                    fontSize: "14px",
                  }}
                />
              </Tabs>
            </Box>

            {activeTab === 1 && <CreatePromoCode setTab={setActiveTab} />}

            {activeTab === 0 && (
              <Box>
                {/* Search Box - Added here */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mb: 2,
                  }}
                >
                  <TextField
                    placeholder="Search promocodes..."
                    variant="outlined"
                    size="small"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon color="action" />
                        </InputAdornment>
                      ),
                      endAdornment: searchTerm && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={handleClearSearch}
                            sx={{ padding: "4px" }}
                          >
                            <Typography variant="body2" color="textSecondary">
                              ✕
                            </Typography>
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      width: 300,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                      },
                    }}
                  />
                </Box>

                <TableContainer
                  component={Paper}
                  elevation={0}
                  sx={{ border: "1px solid #e0e0e0" }}
                >
                  <Table sx={{ minWidth: 1200 }}>
                    <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            fontSize: "11px",
                            textTransform: "uppercase",
                            color: "text.secondary",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Code & Title
                        </TableCell>

                        <TableCell
                          sx={{
                            fontWeight: 600,
                            fontSize: "11px",
                            textTransform: "uppercase",
                            color: "text.secondary",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Price
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            fontSize: "11px",
                            textTransform: "uppercase",
                            color: "text.secondary",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Discount(%)
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            fontSize: "11px",
                            textTransform: "uppercase",
                            color: "text.secondary",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Usage
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            fontSize: "11px",
                            textTransform: "uppercase",
                            color: "text.secondary",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Valid Until
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            fontSize: "11px",
                            textTransform: "uppercase",
                            color: "text.secondary",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Description
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            fontSize: "11px",
                            textTransform: "uppercase",
                            color: "text.secondary",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Applicable Platform
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            fontSize: "11px",
                            textTransform: "uppercase",
                            color: "text.secondary",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Status
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            fontSize: "11px",
                            textTransform: "uppercase",
                            color: "text.secondary",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Approval Status
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            fontSize: "11px",
                            textTransform: "uppercase",
                            color: "text.secondary",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {promoCodeData && promoCodeData.length > 0 ? (
                        promoCodeData.map((row) => (
                          <TableRow
                            key={row.id}
                            sx={{
                              "&:hover": { backgroundColor: "#f9f9f9" },
                              "& td": { borderBottom: "1px solid #f0f0f0" },
                            }}
                          >
                            <TableCell sx={{ verticalAlign: "top" }}>
                              <Box>
                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: 500, mb: 0.5 }}
                                >
                                  {row.discount_code}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  {row.title}
                                </Typography>
                              </Box>
                            </TableCell>

                            <TableCell sx={{ verticalAlign: "top" }}>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 500 }}
                              >
                                {row.discount_value}
                              </Typography>
                            </TableCell>
                            <TableCell sx={{ verticalAlign: "top" }}>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 500 }}
                              >
                                {row.discount_percent}
                              </Typography>
                            </TableCell>
                            <TableCell sx={{ verticalAlign: "top" }}>
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Box
                                  sx={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: "50%",
                                    backgroundColor: "#2196f3",
                                    mr: 1,
                                  }}
                                />
                                <Typography variant="body2">{`${row.usage_count}/${row.usage_limit}`}</Typography>
                              </Box>
                            </TableCell>
                            <TableCell sx={{ verticalAlign: "top" }}>
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Box
                                  sx={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: "50%",
                                    backgroundColor: "#ff9800",
                                    mr: 1,
                                  }}
                                />
                                <Typography variant="body2">
                                  {row.valid_to}
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell
                              sx={{ maxWidth: 300, verticalAlign: "top" }}
                            >
                              <Typography
                                variant="body2"
                                sx={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                  lineHeight: 1.4,
                                }}
                              >
                                {row.description}
                              </Typography>
                            </TableCell>
                            <TableCell
                              sx={{ maxWidth: 300, verticalAlign: "top" }}
                            >
                              <Typography
                                variant="body2"
                                sx={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                  lineHeight: 1.4,
                                }}
                              >
                                {row?.applicable_platform==1?"Web":row.applicable_platform==2?"Mobile":"Both"}
                              </Typography>
                            </TableCell>
                            <TableCell sx={{ verticalAlign: "top" }}>
                              <Chip
                                label={row.status === 1 ? "Active" : "Inactive"}
                                size="small"
                                sx={{
                                  minWidth: 80,
                                  fontWeight: 500,
                                  color: "white",
                                  backgroundColor: getStatusColor(
                                    row.status === 1 ? "Active" : "Inactive"
                                  ),
                                  fontSize: "12px",
                                }}
                              />
                            </TableCell>

                            <TableCell sx={{ verticalAlign: "top" }}>
                              <Chip
                                label={
                                  row.approval_status === 1
                                    ? "Approved"
                                    : row.approval_status === 2
                                    ? "Pending"
                                    : "Rejected"
                                }
                                size="small"
                                sx={{
                                  minWidth: 80,
                                  color: "white",
                                  fontWeight: 500,
                                  fontSize: "12px",
                                  backgroundColor: getStatusColor(
                                    row.approval_status === 1
                                      ? "Approved"
                                      : row.approval_status === 2
                                      ? "Pending"
                                      : "Rejected"
                                  ),
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ verticalAlign: "top" }}>
                              <Box sx={{ display: "flex", gap: 1 }}>
                                <IconButton
                                  size="small"
                                  onClick={() => handleView(row.id)}
                                  sx={{
                                    color: "#2196f3",
                                    backgroundColor: "rgba(33, 150, 243, 0.1)",
                                    "&:hover": {
                                      backgroundColor:
                                        "rgba(33, 150, 243, 0.2)",
                                    },
                                  }}
                                >
                                  <ViewIcon fontSize="small" />
                                </IconButton>
                                <IconButton
                                  size="small"
                                  onClick={() => handleEdit(row.id)}
                                  sx={{
                                    color: "#ff9800",
                                    backgroundColor: "rgba(255, 152, 0, 0.1)",
                                    "&:hover": {
                                      backgroundColor: "rgba(255, 152, 0, 0.2)",
                                    },
                                  }}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                                <IconButton
                                  size="small"
                                  onClick={() => handleDelete(row)}
                                  sx={{
                                    color: "#f44336",
                                    backgroundColor: "rgba(244, 67, 54, 0.1)",
                                    "&:hover": {
                                      backgroundColor: "rgba(244, 67, 54, 0.2)",
                                    },
                                  }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={9} align="center" sx={{ py: 3 }}>
                            <Typography variant="body2" color="text.secondary">
                              {searchTerm
                                ? "No promocodes found matching your search."
                                : "No promocodes available."}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Pagination */}
                <Box className="button-box">
                  {promoCodeData?.length > 0 && (
                    <Pagination
                      count={totalPages}
                      page={page}
                      onChange={handlePageChange}
                      color="primary"
                    />
                  )}
                </Box>
              </Box>
            )}
          </CardContent>

          {/* Delete Confirmation Dialog */}
          <Dialog
            open={deleteDialogOpen}
            onClose={handleDeleteCancel}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: "#f44336",
              }}
            >
              <WarningIcon />
              Delete Promo Code
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to delete the following promo code?
              </DialogContentText>
              {selectedPromoCode && (
                <Box sx={{ mt: 2, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                    Code: {selectedPromoCode.discount_code}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 0.5 }}
                  >
                    Title: {selectedPromoCode.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Discount: {selectedPromoCode.discount_percent}%
                  </Typography>
                </Box>
              )}
              <DialogContentText sx={{ mt: 2, color: "#f44336" }}>
                This action cannot be undone.
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <CustomButton
                variant="contained"
                className="cancel-button"
                type="button"
                text={"Cancel"}
                onClick={handleDeleteCancel}
              />
              <CustomButton
                variant="contained"
                className="success-button"
                type="button"
                loading={deleteLoading}
                text={"Delete"}
                onClick={handleDeleteConfirm}
              />
            </DialogActions>
          </Dialog>
        </Card>
      </Box>
    </>
  );
};

export default PromoCodeManagement;
